export default __webpack_public_path__ + "static/media/1694.0d5f38d4.png";